import * as React from 'react';
import * as Yup from 'yup';
import FormikForm from '~/lib/forms/FormikForm';
import SaleHeader from './SaleHeader';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import Button from '~/common/elements/mobile/Button';
import { buttonColor, buttonSize, buttonStyle } from '~/common/elements/mobile/consts';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';


const saleSchema = Yup.object().shape({});

type Props = {
  onBack: any,
  onHelp: any,
  initialValues: any,
  actionKeyBack: number,
  errorMessage: string,
}

const SaleStepResult = (props: Props) => {
  const {
    initialValues,
    onBack,
    onHelp,
    actionKeyBack,
    errorMessage,
  } = props;

  const handleBack = () => {
    if (onBack) onBack();
  };

  const handleHelp = () => {
    if (onHelp) onHelp(actionKeyBack);
  };

  return (
    <FormikForm // TODO: Fix styles of the page or ask @gio for error page style
      initialValues={initialValues}
      validationSchema={saleSchema}
      render={() => {

        return (
          <PageMobileWrapper>
            <SaleHeader
              onBack={handleBack}
              onHelp={handleHelp}
              title="Result"
            />

            <BodyWrapper>
              <div className="m__body__i lg"><span className="i i-truck" /></div>
              <div className="m__body__titl--lg" style={{ color: 'red' }}>{errorMessage ? errorMessage : 'Bad Request'}</div>
            </BodyWrapper>

            <FooterWrapper>
              <Button
                title="try again"
                buttonStyle={buttonStyle.OUTL_LITE}
                buttonSize={buttonSize.XLG}
                buttonColor={buttonColor.PRIM}
                onClick={handleBack}
              />
            </FooterWrapper>
          </PageMobileWrapper>
        );
      }}
    />
  );
};

export default SaleStepResult;
